var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 768,
    height: 728.85799,
    viewBox: "0 0 768 728.85799",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.88391,258.51823h-3.99878V148.9729A63.40187,63.40187,0,0,0,615.48334,85.571H383.39661a63.40184,63.40184,0,0,0-63.402,63.40171V749.94712A63.40181,63.40181,0,0,0,383.39642,813.349H615.483a63.40185,63.40185,0,0,0,63.402-63.40167V336.49449h3.99884Z",
    transform: "translate(-216 -85.571)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M618.04138,102.066h-30.295a22.49486,22.49486,0,0,1-20.82715,30.99052H433.95978A22.4948,22.4948,0,0,1,413.13263,102.066H384.837a47.34781,47.34781,0,0,0-47.34784,47.34774V749.50627A47.34781,47.34781,0,0,0,384.837,796.85411h233.2044a47.34781,47.34781,0,0,0,47.34784-47.34778h0V149.41371a47.34777,47.34777,0,0,0-47.34784-47.3477Z",
    transform: "translate(-216 -85.571)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149.43143,
    y: 128.24738,
    width: 135.60425,
    height: 231.65729,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 308.33337,
    y: 378.05048,
    width: 112.70621,
    height: 262.26761,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 308.44357,
    y: 128.24738,
    width: 113.00354,
    height: 63.7663,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 308.44357,
    y: 209.77137,
    width: 113.00354,
    height: 68.60928,
    fill: "#b4002f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 308.44357,
    y: 296.13837,
    width: 113.00354,
    height: 63.7663,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 149.59921,
    y: 378.05048,
    width: 135.60425,
    height: 100.95499,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 149.59921,
    y: 498.57563,
    width: 135.60425,
    height: 141.95499,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M809.22124,373.55053c0,22.04505-20.38417,18.71067-45.52931,18.71067s-45.5293,3.33438-45.5293-18.71067,9.95715-61.12153,45.5293-61.12153C800.48959,312.429,809.22124,351.50547,809.22124,373.55053Z",
    transform: "translate(-216 -85.571)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M635.22131,333.46045a12.54331,12.54331,0,0,0,7.7483,17.604l2.2944,44.51578,18.6553-13.73043-5.03886-40.16792a12.61133,12.61133,0,0,0-23.65914-8.22141Z",
    transform: "translate(-216 -85.571)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M839.73187,585.0357a12.54337,12.54337,0,0,0-5.47911-18.43681l3.30718-44.452L817.32981,533.429l-.03906,40.48272a12.61133,12.61133,0,0,0,22.44112,11.124Z",
    transform: "translate(-216 -85.571)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "530.567 713.445 545.859 713.445 553.134 654.459 530.564 654.46 530.567 713.445",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M742.66591,794.02351l30.11644-.00122h.00122a19.19222,19.19222,0,0,1,19.19275,19.19245v.62369l-49.3095.00182Z",
    transform: "translate(-216 -85.571)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "627.862 713.445 643.155 713.445 650.43 654.459 627.86 654.46 627.862 713.445",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M839.9614,794.02351l30.11645-.00122h.00122a19.19222,19.19222,0,0,1,19.19275,19.19245v.62369l-49.3095.00182Z",
    transform: "translate(-216 -85.571)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M835.13368,560.54394l-.6645-.1206c-5.57026-1.00862-11.20813-2.02821-16.16506-3.09408l-.4906-.106-.00183-.50187c-.085-22.61-.17024-45.21624-.2954-68.02719a143.79,143.79,0,0,1-14.37683-77.07433l.028-.28017.22993-.16445a14.78633,14.78633,0,0,1,14.90154-1.15236,16.52117,16.52117,0,0,1,8.481,12.542c4.50774,24.5675,9.17444,50.00841,14.37926,75.07779l.01919.09136-.00883.0938c-1.92832,20.44531-3.92212,41.58739-5.9686,62.04366Z",
    transform: "translate(-216 -85.571)",
    fill: "#b4002f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M825.1644,777.99339l-.12151-.575c-7.15415-33.84-14.06011-61.39683-20.73888-88.04614-8.0035-31.93727-15.588-62.2008-23.24491-101.36409,1.05157,49.38716,3.49394,84.86922,6.30146,125.65386,1.26778,18.41588,2.5785,37.45911,3.90841,59.69021l.04081.67851-.67912-.01706c-23.93407-.61272-48.45559-2.09155-72.17009-3.52043l-.62734-.03776.04264-.62734c4.48977-66.178,5.89672-109.18092,6.92392-140.581,2.16738-66.24626,2.50054-76.42871,27.17707-132.49373.93523-2.12688,6.51584-8.41128,12.65133-7.45382l48.5506,7.55614.085.42757c1.37041,6.90078,8.16887,27.84065,17.57841,56.8227,20.11519,61.956,50.51334,155.58485,60.00967,211.39528l.10751.63222-.63466.09014c-13.793,1.96-23.72,4.0016-33.32016,5.975-9.08308,1.86863-18.475,3.79939-31.25937,5.707Z",
    transform: "translate(-216 -85.571)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M782.96763,514.369c-12.9583.00122-25.76646-4.49495-34.94821-13.24974a10.36322,10.36322,0,0,1-5.11255-8.05436,10.50795,10.50795,0,0,1,2.46826-8.52578c-9.00207-10.89629-18.2965-22.158-27.19351-33.62561l-.24576-.31672.28474-.54329c5.8209-11.12165,11.84-22.62091,17.62044-33.98375a5.93781,5.93781,0,0,1,4.84211-3.66661,6.90339,6.90339,0,0,1,5.3309,1.19134l.01157-.27651c.2415-5.75207.4833-11.50414.7315-16.95655l.02649-.58227.58288-.0134c11.11434-.24485,22.60691-.49944,33.89574-1.1682l.4297-.02558,5.59889,12.48961a45.79477,45.79477,0,0,1,26.27412,5.333l.36971.19734-.04294.41661a254.28717,254.28717,0,0,0,1.4575,64.4702c-.1748,9.74393-.3627,19.70346-2.33974,27.6421l-.05756.23145-.19795.134A53.2643,53.2643,0,0,1,782.96763,514.369Z",
    transform: "translate(-216 -85.571)",
    fill: "#b4002f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M735.27,460.18359l-.74581-.3423c-8.707-4.36826-17.44137-9.214-25.888-13.90022l-1.167-.2278c-22.23993-4.46449-34.4908-6.9227-54.55513-18.68874l-.1541-.09136-.08283-.15836c-10.04663-19.19184-12.849-35.9681-10.3399-61.89749l.05025-.52015.52015-.04141c2.175-.17663,5.72009-.29479,9.14825-.4093,3.33527-.11085,6.78414-.22657,8.89853-.39224l.49061-.039.15166.46776c2.62905,8.11893,4.86252,15.69334,7.22724,23.71237,2.4305,8.24317,4.94261,16.76286,8.00259,26.229,11.20356,3.21955,41.23778,2.25722,50.57637.98548,5.38906-.553,10.83325,1.93806,14.59031,6.634l.17328.21683-.04477.27409c-2.05592,12.54687-4.41668,25.168-6.69948,37.37383Z",
    transform: "translate(-216 -85.571)",
    fill: "#b4002f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 763.13209,
    cy: 360.40883,
    r: 30.63688,
    transform: "translate(-135.15423 771.57768) rotate(-61.33679)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M728.14165,358.582v0h12.11748l5.34582-14.96854,1.06892,14.96854h5.79166l3.11844-8.73165.62369,8.73165h43.03455v0a32.4318,32.4318,0,0,0-32.4318-32.4318h-6.237A32.4318,32.4318,0,0,0,728.14165,358.582Z",
    transform: "translate(-216 -85.571)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M983,814.429H217a1,1,0,0,1,0-2H983a1,1,0,0,1,0,2Z",
    transform: "translate(-216 -85.571)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.1f4eaddab4837fbbc192aad48f9c2297.svg";
export { ForwardRef as ReactComponent };